module.exports = "../images/childrens-play-area.svg?v=0298fda";